import React from 'react';
import { StyleSheet, View, TouchableOpacity, Platform, Text, ScrollView } from 'react-native';
import NavBar from 'src/presentation/components/organisms/NavBar';
import Title from 'src/presentation/components/atoms/Title';
import Cta from 'src/presentation/components/atoms/Cta';
import Footer from 'src/presentation/components/organisms/Footer';
import { useFooterHeight } from 'src/presentation/hooks/useFooterHeight';
import { useEventStore } from 'src/domain/stores/useEventStore';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import Fonts from 'src/core/utils/Fonts';

function FormClosedScreen() {
	const eventStore = useEventStore();
	const { openEmail } = useServicesStore();
	const footerHeight = useFooterHeight();

	return (
		<View style={{ flex: 1 }}>
			<NavBar
				backBtn={true}
				backStep={2}
				bgImage={eventStore.activeTheme.header_bg_image}
				bgcolor={eventStore.activeTheme.header_bg_color}
				color={eventStore.activeTheme.header_text_color}
				editBtn={false}
				statusBarStyle={eventStore.activeTheme.statusbar_color}
				title={Translations.titleFormClosed}
			/>
			<ScrollView
				contentContainerStyle={{ paddingBottom: footerHeight }}
				style={StyleSheet.flatten(styles.contentContainer)}
			>
				<Title text={Translations.titleFormClosed} />
				<Text style={styles.text}>
					Helaas, dit formulier is gesloten. Wil je nog een wijziging aanbrengen, je afmelden of juist nog aanmelden? Stuur
					dan een e-mail naar de organisatie met jouw verzoek.
				</Text>
				<View style={styles.ctaContainer}>
					<TouchableOpacity onPress={() => openEmail({ email: 'Elise.Oude.Scholten@topicus.nl' }).catch(() => undefined)}>
						<Cta label={Translations.buttonSendEmail} labelColor={Colors.white} style={styles.button} upperCase={true} />
					</TouchableOpacity>
				</View>
			</ScrollView>

			<Footer
				backgroundColor={eventStore.activeTheme.footer_bg_color}
				backgroundImage={eventStore.activeTheme.footer_bg_image}
				backgroundType={eventStore.activeTheme.footer_bg_type}
			/>
		</View>
	);
}

const styles = StyleSheet.create({
	contentContainer: {
		marginBottom: Platform.OS === 'android' ? Dimens.margin5 : Dimens.margin30,
	},
	button: {
		backgroundColor: Colors.greyDark,
	},
	text: {
		flex: 1,
		paddingLeft: Platform.OS === 'ios' ? Dimens.padding20 : Dimens.padding16,
		paddingRight: Platform.OS === 'ios' ? Dimens.padding20 : Dimens.padding16,
		paddingTop: Platform.OS === 'ios' ? Dimens.padding5 : Dimens.padding5,
		paddingBottom: Platform.OS === 'ios' ? Dimens.padding15 : Dimens.padding8,
		fontSize: Dimens.fontSize17,
		fontFamily: Fonts.montserratRegular,
		lineHeight: Dimens.lineHeight23,
	},
	ctaContainer: {
		marginTop: 50,
		width: '100%',
		flex: 1,
		justifyContent: 'center',
		alignItems: 'center',
	},
});

export default FormClosedScreen;
